/**
 * DKG Keyshare Service
 *
 * Provides V2 status checks for DKG nodes.
 */

// Configuration for DKG nodes
const DKG_NODE_URLS = [
    process.env.REACT_APP_DKG_NODE_1 || 'http://localhost:8081',
    process.env.REACT_APP_DKG_NODE_2 || 'http://localhost:8082',
    process.env.REACT_APP_DKG_NODE_3 || 'http://localhost:8083',
    process.env.REACT_APP_DKG_NODE_4 || 'http://localhost:8084',
    process.env.REACT_APP_DKG_NODE_5 || 'http://localhost:8085',
];

/**
 * Get V2 status from all nodes
 */
async function getV2Status() {
    const statusChecks = DKG_NODE_URLS.map(async (nodeUrl) => {
        try {
            const response = await fetch(`${nodeUrl}/api/v2/status`);
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            return {
                nodeUrl,
                nodeId: data.node_id,
                masterInitialized: data.master_initialized,
                masterSeeds: data.master_seeds,
                threshold: data.threshold,
                totalNodes: data.total_nodes,
                healthy: true,
            };
        } catch (error) {
            return {
                nodeUrl,
                healthy: false,
                error: error.message,
            };
        }
    });

    return Promise.all(statusChecks);
}

export {
    getV2Status,
};
